import { createContext } from "react";
const SubscriptionWorkflowContext = createContext();
const { Provider } = SubscriptionWorkflowContext;

export default SubscriptionWorkflowContext;
export { Provider };
